var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader" }, [
      _c("div", { staticClass: "spinner-cont" }, [
        _c("i", { staticClass: "fal fa-spinner fa-spin" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }